import React, {useEffect, useRef, useState} from 'react';
import 'styles/chat/MessageItem.css';
import {useNavigate} from 'react-router-dom';
import UniversalProfileImage from 'components/universal/UniversalProfileImage';
import ThreeDotOptions from 'components/universal/ThreeDotOptions';
import ReportMessagePopup from 'components/chat/ReportMessagePopup';
import {usePopup} from 'popup/PopupContext';

function MessageItem({msg, isBottomMessage}) {
    const navigate = useNavigate();
    const [optionsOpened, setOptionsOpened] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const {openPopup} = usePopup();
    const [showTime, setShowTime] = useState(false);
    const isListening = useRef(false);
    const lastClicked = useRef(0); // To track the last click time

    useEffect(() => {
        setIsActive(isHovered || optionsOpened);
    }, [optionsOpened, isHovered]);

    const handleClickOutside = () => {
        const now = Date.now();
        if (now - lastClicked.current < 10) return; // Ignore clicks within 10ms of toggle
        setShowTime(false);
    };

    useEffect(() => {
        if (showTime && !isListening.current) {
            document.addEventListener('click', handleClickOutside);
            isListening.current = true;
        } else if (!showTime && isListening.current) {
            document.removeEventListener('click', handleClickOutside);
            isListening.current = false;
        }

        return () => {
            if (isListening.current) {
                document.removeEventListener('click', handleClickOutside);
                isListening.current = false;
            }
        };
    }, [showTime]);

    const handleImageClick = () => {
        navigate(`/profile/${msg.senderId}`);
    };

    const handleReport = () => {
        openPopup(<ReportMessagePopup msg={msg} type={'message'}/>);
    };

    const handleMessageClick = (e) => {
        if (e.target.closest('.chat-options-icon-wrapper')) return;
        lastClicked.current = Date.now(); // Update the last clicked time
        setShowTime(!showTime);
    };

    return (
        <>
            <div className="message-bubble">
                <div className="message-profile-image cursor-pointer" onClick={handleImageClick}>
                    <UniversalProfileImage id={msg.profilePictureId} size={'100%'}/>
                </div>

                <div
                    className={`message-content ${isActive ? 'active' : ''}`}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={handleMessageClick}
                >
                    <p className="username">{msg.username}:</p>
                    <p className="text-content">{msg.message}</p>
                    {isActive && (
                        <div
                            className="chat-options-icon-wrapper"
                            onClick={(e) => e.stopPropagation()} // Prevent click propagation
                        >
                            <ThreeDotOptions
                                elements={{
                                    report: 'Report Message',
                                }}
                                onElementClick={handleReport}
                                isBottomMessage={isBottomMessage}
                                onOpenStateChange={setOptionsOpened}
                            />
                        </div>
                    )}
                </div>
            </div>
            {showTime && (
                <div className="chat-time" onClick={() => setShowTime(false)}>
                    {new Date(msg.time).toLocaleString()}
                </div>
            )}
        </>
    );
}

export default MessageItem;
